<template>
  <v-card style="border-radius: 10px;">
    <v-container fluid>

      <div slot="label"><h2>{{ this.i18n('Provedor de taxa de câmbio')}}</h2></div>
      <v-radio-group row v-model="exchangeRateProvider">
        <v-radio label="TradingView" value="tradingview"></v-radio>
        <v-radio label="Broadcast" value="broadcast"></v-radio>
      </v-radio-group>

      <div slot="label"><h2>Estado Mesa de Câmbio</h2></div>
      <v-radio-group row v-model="backOfficeStatus">
        <v-radio :label="('Aberta')" value="active"></v-radio>
        <v-radio :label="('Fechada')" value="inactive"></v-radio>
        <v-radio :label="('Automática')" value="auto"></v-radio>
      </v-radio-group>
      <div slot="label"><h2>Limite Nível 1</h2></div>
      <v-currency-field
        box
        v-bind="currency_config"
        v-model="clearanceLevelLimit"
      ></v-currency-field>
      <div slot="label" v-if="Object.keys(payoutAccounts).length">
        <h2>Contas de Payout</h2>
        <ul>
          <li>As contas serão exibidas nesta ordem na página 'Transferências em Espera', ao selecionar um pagamento</li>
          <li>Ao editar, adicionar ou apagar uma conta, clique em "Atualizar" para gravar as alterações.</li>
        </ul>
        <br>
        <div v-for="(accounts, currency) in payoutAccounts" :key="currency" class="mb-4">
          <h3>{{ currency }}</h3>
          <v-list dense>
            <div v-for="(accountId, idx) in accounts" :key="accountId" style="display: flex; align-items: center;">
              <v-text-field
                v-model="accounts[idx]"
                :label="`Conta ${idx + 1}`"
                style="flex: 1;"
              />
              <v-icon
                v-if="accounts.length > 1"
                color="red"
                class="ml-2"
                style="cursor:pointer"
                @click="removePayoutAccountId(currency, idx)"
              >
                close
              </v-icon>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" @mouseenter="fetchAccountInfo(accountId)" dark v-on="on">info</v-icon>
                </template>
                <span>{{selectedAccountData}}</span>
              </v-tooltip>
            </div>
          </v-list>
          <v-btn small color="primary" @click="addPayoutAccountId(currency)">
            {{`Adicionar Conta ${currency}`}}
          </v-btn>
        </div>
      </div>
      <v-btn
        dark
        :disabled="loading"
        color="#41DFC4"
        @click="updateConfig"
      >
        Atualizar
        <v-progress-circular :indeterminate="loading" :value="0" size="22" class="ml-2"></v-progress-circular>
      </v-btn>
      <v-snackbar v-model="displayFeedback" :color="feedbackColor" :timeout="3000" bottom>
        {{feedbackText}}
      </v-snackbar>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'APIConfigFIelds',
  components: {  },
  data() {
    return {
      admin: false,
      loading: true,
      feedbackText: '',
      lastSearchedId: '',
      displayFeedback: false,
      feedbackColor: 'blue',
      token: this.$cookies.get('api_token'),
      selectedAccountData: 'Carregando...',
      payoutAccounts: {},
      backOfficeStatus: '',
      exchangeRateProvider: '',
      clearanceLevelLimit: '',
      currency_config: {
        decimal: ",",
        thousands: "."
      },
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },

    loadAPiConfig() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.backOfficeStatus = response.body.data.backoffice_status
          this.clearanceLevelLimit = response.body.data.clearance_level_limit
          this.payoutAccounts = response.body.data.payout_accounts || {}
          this.exchangeRateProvider = response.body.data.exchange_rate_provider || 'tradingview'
        } else {
          console.log(response)
        }
        this.loading = false
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      this.$http.get(this.$root.urls.admin__config, { headers: { Authorization: `Bearer ${this.token}` }})
        .then(successCallback, errorCallback)
    },

    updateConfig() {
      this.loading = true
      const payload = { "api_config": {
          "backoffice_status": this.backOfficeStatus,
          "clearance_level_limit": this.clearanceLevelLimit,
          "payout_accounts": this.payoutAccounts,
          "exchange_rate_provider": this.exchangeRateProvider
        }
      }

      let successCallback = (response) => {
        this.feedbackColor = 'green'
        this.displayFeedback = true
        this.feedbackText = 'A configuração foi atualizada com sucesso'
        this.loading = false
      }

      let errorCallback = (response) => {
        this.loading = false
        if (response.body.errors) {
          let errors = response.body.errors

          for (let field in errors) {
            errors[field] = errors[field].map((error_msg) => {
              return utils.translateErrorMessage(error_msg, this.$root.lang)
            })
          }

          this.errors = errors
        }
      }

      this.errors = {}

      if (!this.validatePayoutAccounts(payload.api_config.payout_accounts)) {
        this.feedbackColor = 'red'
        this.displayFeedback = true
        this.feedbackText = 'Algum ID de conta de payout é inválido. Verifique e tente novamente.'
        this.loading = false
        return;
      }

      this.$http
        .put(this.$root.urls.admin__config, payload, { headers: { Authorization: `Bearer ${this.token}` } })
        .then(successCallback, errorCallback)
    },
    fetchAccountInfo(accountId) {
      if (!this.isValidUUID(accountId) || accountId === this.lastSearchedId) return;
      this.selectedAccountData = 'Carregando...';
      this.$http.get(`${this.$root.urls.bank_accounts}${accountId}`, { headers: { Authorization: `Bearer ${this.token}` } })
        .then(response => {
          if (response.body && response.body.data) {
            const {bank, account_number, currency} = response.body.data;
            this.selectedAccountData = `${bank.name} - ${account_number} (${currency})`;
          } else {
            this.selectedAccountData = 'Não encontrada';
          }
        })
        .catch(() => {
          this.selectedAccountData = 'Erro ao buscar';
        });
        this.lastSearchedId = accountId;
    },
    addPayoutAccountId(currency) {
      if (!this.payoutAccounts[currency]) {
        this.$set(this.payoutAccounts, currency, []);
      }
      this.payoutAccounts[currency].push('');
      this.feedbackColor = 'blue'
      this.displayFeedback = true
      this.feedbackText = 'Cole o ID da conta e clique em "Atualizar" para salvar.'
    },
    removePayoutAccountId(currency, idx) {
      this.payoutAccounts[currency].splice(idx, 1)
      this.feedbackColor = 'blue'
      this.displayFeedback = true
      this.feedbackText = 'Conta removida da lista. Clique em "Atualizar" para salvar.'
    },
    isValidUUID(uuid) {
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
    },
    validatePayoutAccounts(payoutAccounts) {
      for (const currency in payoutAccounts) {
        for (const id of payoutAccounts[currency]) {
          if (!this.isValidUUID(id)) {
            return false;
          }
        }
      }
      return true;
    }
  },
  mounted() {
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    this.loadAPiConfig()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/APIConfigFields.vue